type Tab = { id: string; lastActiveAt: number | null };

export function mostRecentlyActiveTab<T extends Tab>(
  tabs: readonly T[]
): T | undefined {
  return tabs.reduce<T | undefined>(
    (best, t) =>
      !best || (t.lastActiveAt ?? 0) > (best.lastActiveAt ?? 0) ? t : best,
    undefined
  );
}

export function nextChatIdAfterDelete({
  tabs,
  pendings,
  deletedIds,
}: {
  tabs: readonly Tab[];
  pendings: readonly { id: string }[];
  deletedIds: readonly string[];
}): string | null {
  const deleted = new Set(deletedIds);
  const remaining = mostRecentlyActiveTab(
    tabs.filter((t) => !deleted.has(t.id))
  );
  if (remaining) return remaining.id;
  return pendings.find((p) => !deleted.has(p.id))?.id ?? null;
}
